import { trackEvent } from './segment';

export const trackShopBrowseCatalogClick = ({ source }) => {
  trackEvent({
    event: 'account_menu_browse_catalog',
    properties: {
      source
    }
  });
};

export const trackShopLandingView = () => {
  trackEvent({
    event: 'shop_homepage_visit'
  });
};

export const trackShopSearch = ({
  productGridFilterNames,
  searchTerm,
  searchResultsCnt
}) => {
  trackEvent({
    event: 'shop_text_search',
    properties: {
      number_of_results: searchResultsCnt,
      product_grid_filter_names: productGridFilterNames,
      search_term: searchTerm
    }
  });
};

export const trackShopPDPView = ({
  product,
  productGridFilterNames,
  searchTerm,
  tileCardPlaceInProductGrid
}) => {
  trackEvent({
    event: 'shop_pdp_view',
    properties: {
      primary_referral_source: tileCardPlaceInProductGrid >= 0 ? 'tile_card' : 'cart',
      product: product && product.getSegmentProperties(),
      product_grid_filter_names: productGridFilterNames,
      search_term: searchTerm,
      tile_card_place_in_product_grid: tileCardPlaceInProductGrid
    }
  });
};

export const trackShopAddToCart = ({
  primaryReferralSource,
  product,
  productGridFilterNames,
  searchTerm,
  tileCardPlaceInProductGrid
}) => {
  trackEvent({
    event: 'shop_add_to_cart',
    properties: {
      primary_referral_source: primaryReferralSource,
      product: product && product.getSegmentProperties(),
      product_grid_filter_names: productGridFilterNames,
      search_term: searchTerm,
      tile_card_place_in_product_grid: tileCardPlaceInProductGrid
    }
  });
};

export const trackShopRemoveFromCart = ({
  product
}) => {
  trackEvent({
    event: 'shop_remove_from_cart',
    properties: {
      product: product && product.getSegmentProperties()
    }
  });
};

export const trackCartLearnMore = () => {
  trackEvent({
    event: 'studio_cart_tooltip_clicked',
    properties: {}
  });
};

export const trackMicroShopBannerClick = ({
  microshopName
}) => {
  trackEvent({
    event: 'shop_promo_banner_click',
    properties: {
      microshop_name: microshopName
    }
  });
};

export const trackShopCategoryClick = ({
  categoryName,
  isBackLink,
  isSale
}) => {
  trackEvent({
    event: 'shop_categories_click',
    properties: {
      category_name: categoryName,
      is_backlink: isBackLink,
      is_sale: isSale
    }
  });
};
